import React from 'react'
import Image from 'next/image'

const InteractionsSection = ({ data = null , customClass , textColor =null }) => {
  return (
    <>
      {(data) &&
        <>
          <div className="grid grid-cols-12 gap-4">
            {data?.map((item, index) => (
              <div key={index} className={ customClass != null ? customClass : 'md:col-span-6 col-span-12'}>
                <div className={textColor ? textColor : "text-white"}>
                  <div className="flex items-center">
                    <Image priority={false} 
                        width={2000} 
                        height={2000} 
                        className="w-10 h-10 mr-3" 
                        alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'} 
                        src={process.env.IMG_CDN+item?.imageSrc} 
                    />
                    <h3 className="text-xl font-semibold">{item?.title}</h3>
                  </div>
                  <p className="my-2">{item?.description}</p>
                </div>
              </div>
            ))}
          </div>
        </>
      }
    </>
  )
}

const InteractionsSample = React.memo(InteractionsSection);

export default InteractionsSample;0 
